import React, { Suspense } from "react";
import { userRoutes, authRoutes } from "./allRoutes";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
/* Layout */
import CommonLayout from "../Layout/CommonLayout/index";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";
import Error404 from "../pages/ExtraPages/Error404";
import { UnauthenticatedTemplate } from "@azure/msal-react";
const Index = () => {
  const availableAuthRoutesPath = authRoutes.map((r) => r["path"]);
  // const availablePublicRoutesPaths = userRoutes.map((r) => r["path"]);

  const msalInstance = new PublicClientApplication(msalConfig);
  
  const Loader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <ul>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Router>
        <Suspense fallback={Loader()}>
          <Switch>
            <Route path={availableAuthRoutesPath} exact>
              <CommonLayout>
                {authRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    component={route.component}
                    key={idx}
                    exact={true}
                  />
                ))}
              </CommonLayout>
            </Route>
            <Route path="*">
              <Error404></Error404>
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </React.Fragment>
  );
};

export default Index;
